import { FormDocument } from "prismicio-types";
import { useGetProduct } from "queries/product-queries";
import { SSR_CONFIGURATION_ERROR } from "utils/error-utils";

import styles from "./Drawers.module.scss";
import Drawer from "./drawer/Drawer";

type DrawersProps = {
  onDrawerClicked: (form: FormDocument) => void;
};

export default function Drawers({ onDrawerClicked }: DrawersProps) {
  const { data: product } = useGetProduct();

  if (!product) {
    throw SSR_CONFIGURATION_ERROR;
  }

  return (
    <div className={styles.drawers}>
      {product.content.product.drawers.map((drawer) => (
        <Drawer
          key={drawer.label}
          data={drawer}
          onDrawerClicked={onDrawerClicked}
        />
      ))}
    </div>
  );
}
